"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StressFreeWeddingPlanning() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section className="relative py-16 md:py-24 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1501731/img/image_m77ulrhs.jpg)]">
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-white/95 to-white/90"></div>
      
      {}
      <div className="relative mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div ref={contentRef} className="space-y-6 transition-all duration-[150ms] ease-out" style={{
        opacity: contentVisible ? 1 : 0,
        transform: contentVisible ? "translateY(0)" : "translateY(20px)"
      }}>
          <h2 className="font-display text-4xl md:text-5xl text-foreground leading-tight text-center">
            Love weddings, but hate the stress?
          </h2>
          
          <div className="space-y-4 text-foreground/80 font-sans text-base md:text-lg leading-relaxed text-center">
            <p>Let's be honest, traditional wedding photography and videography can feel like another thing you have to manage. Long timelines, rigid packages, awkward posing, and a camera constantly in your face. You spend months planning one of the most important days of your life, only to feel rushed, staged, or pulled away from the moments that actually matter.</p>
            <p>And when you look at cheaper or high-volume options? It often feels transactional. The same poses, the same edits, a stranger with a camera ticking boxes. The emotion gets lost, the story feels flat, and the final result doesn't really feel like you.</p>
            <p>We remove the friction. We take a story-first, people-first approach to wedding photography and videography in Sydney. No forced moments, no rigid timelines, no awkward interruptions. We blend in, capture what's real, and focus on how the day actually felt, not just how it looked. You stay present, we handle the rest, and you walk away with something timeless, personal, and genuinely yours.</p>
          </div>

          <div className="pt-4 flex justify-center">
            <Button asChild size="lg" className="bg-[#B86A5A] text-white hover:bg-[#A55A4A] focus-visible:ring-[#B86A5A]/40 transition-all duration-[120ms] ease-[cubic-bezier(0.34,1.56,0.64,1)] hover:scale-[1.03] active:scale-100">
              <Link to="mailto:aidan.bartlett.photography@gmail.com">Save Your Day With Confidence</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}